'use strict';
import React from 'react';

import Icon from './icon';

/**
 * Defines an underlined section header with a title.
 * An action element can be used to indicate an action which can be performed, or supplementary text.
 * SectionHeader-icon can be used to provide an Icon with action text.
 *
 * @extends {React.Component}
 * @property {String} actionName Renders a set of section header action elements, if defined .
 * @property {String} iconClass Sets the icon to display, if any.
 */
class SectionHeader extends React.Component {

  renderHeaderAction (actionName, iconClass, otherProps) {
    return (
      <div className="SectionHeader-action">
        <a {...otherProps}>
          { !!iconClass ? <Icon className="SectionHeader-icon" iconClass={iconClass}/> : null }
          { actionName }
        </a>
      </div>
    );
  }

  /**
   * @return {JSX} JSX component markup.
   */
  render () {
    const { actionName, children, iconClass, otherProps } = this.props;
    return (
      <div className="SectionHeader">
        <div className="SectionHeader-title">{ children }</div>
        { !!actionName ? this.renderHeaderAction(actionName, iconClass, otherProps) : null }
      </div>
    );
  }
}

/**
 * @prop {propTypes} propTypes attributes for the SectionHeader component
 */
SectionHeader.propTypes = {
  actionName: React.PropTypes.string,
  iconClass: React.PropTypes.string
};

export default SectionHeader;



// WEBPACK FOOTER //
// ./src/components/clarity-ui/components/sectionHeader.jsx